import request from '@/api/config/request'

const prex = "/api/admin/gestao/fiscalizacao/notificacoes";

export function list_simples_nacional_notificacoes(exercicio) {
    return request({
        url: `${prex}/${exercicio}`,
        method: 'get'
    })
}

export function save_nacional_notificacoes(data) {
    return request({
        url: `${prex}`,
        method: 'post',
        data
    })
}
